import React from "react";
import { Box, Drawer, Typography, Divider, Button } from "@mui/material";
import { RxCross2 } from "react-icons/rx";

const BottomSheetCom = ({
  open,
  onClose,
  user_id,
  username,
  mobile,
  GotoProfile,
  GotoOrders,
  handlelikePage,
  gotocontact,
  gotoabout,
  gotohelp,
  logoutfromapp,
  handleprofilePage,
}) => {
  return (
    <Drawer
      anchor="bottom"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderTopLeftRadius: 16,
          borderTopRightRadius: 16,
          padding: "16px 20px",
          boxShadow: "0px -4px 12px rgba(0,0,0,0.1)",
        },
      }}
    >
      <Box sx={{ paddingBottom: 2 }}>
        {/* Header */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 1,
          }}
        >
          <Typography variant="h6" sx={{ color: "#bc8246", fontWeight: 600 }}>
            {user_id ? "Hello" : "Welcome"}
          </Typography>
          <RxCross2
            onClick={onClose}
            style={{
              cursor: "pointer",
              fontSize: 24,
              color: "#666",
              transition: "color 0.2s ease",
            }}
            onMouseOver={(e) => (e.currentTarget.style.color = "#bc8246")}
            onMouseOut={(e) => (e.currentTarget.style.color = "#666")}
          />
        </Box>

        {/* User Info */}
        {user_id ? (
          <Typography variant="h6" sx={{ color: "#777" }}>
            {username || mobile}{" "}
          </Typography>
        ) : (
          <p className="profile_welcome_msg">
            To access account and manage orders
          </p>
        )}
      </Box>

      <Divider
        sx={{
          my: 2,
          backgroundColor: "black",
          height: "1px",
          marginTop: "0px",
        }}
      />

      {/* Navigation List */}
      <Box>
        {[
          {
            label: "My Profile",
            action: user_id ? GotoProfile : handleprofilePage,
          },
          { label: "Orders", action: user_id ? GotoOrders : handleprofilePage },
          // {
          //   label: "Wishlist",
          //   action: user_id ? handlelikePage : handleprofilePage,
          // },
          { label: "Contact Us", action: gotocontact },
          { label: "About Us", action: gotoabout },
          { label: "FAQ", action: gotohelp },
        ].map((item, index) => (
          <Typography
            key={index}
            onClick={item.action}
            sx={{
              cursor: "pointer",
              mb: 1,
              fontSize: "16px",
              fontWeight: 500,
              color: "#333",
              transition: "all 0.2s ease",
              "&:hover": {
                color: "#bc8246",
                transform: "translateX(4px)",
              },
            }}
          >
            {item.label}
          </Typography>
        ))}

        {/* Login / Logout Button */}
        <Button
          variant="outlined"
          fullWidth
          sx={{
            color: "#c1bcbc",
            borderColor: "#c1bcbc",
            textTransform: "none",
            fontWeight: 600,
            mt: 2,
          }}
          onClick={user_id ? logoutfromapp : handleprofilePage}
        >
          {user_id ? "Logout" : "Login"}
        </Button>
      </Box>
    </Drawer>
  );
};

export default BottomSheetCom;
